import React from 'react';
import './Home.css';
import logo from '../logo.svg';

function Home() {
  return (
    <div className="home-container">
      <img src={logo} className="home-logo" alt="logo" />
      <h1 className="home-title">Добро пожаловать!</h1>
      <p className="home-subtitle">Ваш надежный и быстрый VPN-сервис</p>
    </div>
  );
}

export default Home; 
